import React, {Component} from 'react';
import CheckBoxDefaultComponent
    from "../../../../Components/CheckBoxDefaultComponent/CheckBoxDefaultComponent";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import {Box, Button, TableCell, TableRow, Typography} from "@material-ui/core";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {ContentCNPJBlock, DeleteIconStyled} from "../styled";
import DeleteIcon from '@material-ui/icons/Delete';
import FormMask from "../../../../FromMask/FormMask";
import TooltipDefault
    from "../../../../Components/TooltipComponent/TololtipDefault";
import ModalMoreBlockUserComponent from "./ModalMoreBlockUserComponent";
import {FidelityContext} from "../../../../Contexts/FidelityContext";
import {TaxIdValidationUtil} from "../../../../Utils/TaxIdValidationUtil";

class BlockUserComponent extends Component {
    static contextType = FidelityContext;

    constructor(props) {
        super(props);

        this.state = {
            formatValues: {
                allow_manual_scoring_only: false,
                block_invoices_no_owner: false,
                person_invoices_only_owner: false,
                blocked_company_invoices: [],
                blocked_user_allowed_company_invoices: [],
                showModal: false,
            }
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values === prevProps.values) {
            return;
        }
        this.setState({
            formatValues: {
                allow_manual_scoring_only: this.props.values.allow_manual_scoring_only,
                block_invoices_no_owner: this.props.values.block_invoices_no_owner,
                person_invoices_only_owner: this.props.values.person_invoices_only_owner,
                blocked_company_invoices: this.props.values.blocked_company_invoices ?? [],
                blocked_user_allowed_company_invoices: this.props.values.blocked_user_allowed_company_invoices ?? [],
            },
        })
    }

    handleChange = (event) => {
        const {name, value} = event.target;
        this.setState({
            [name]: value,
        });
    }

    addCNPJBlock = () => {
        const cnpjValue = this.state.blocked_company_invoices;

        if (!TaxIdValidationUtil.isValidCNPJ(cnpjValue)) {
            alert('CNPJ inválido');
            return;
        }


        this.state.formatValues.blocked_company_invoices.push({
            cnpj: cnpjValue
        });

        this.setState({
            blocked_company_invoices: '',
        });
        this.onChange();
    }

    deleteCNPJBlock = (index) => {
        this.state.formatValues.blocked_company_invoices = this.state.formatValues.blocked_company_invoices.filter((_, i) => i !== index,);
        this.setState({});
        this.onChange();
    }

    addCNPJCPFBlock = () => {
        const cnpjValue = this.state.blocked_user_allowed_company_invoices;
        const cpfValue = this.state.blocked_user_allowed_company_invoices_cpf;

        if (!TaxIdValidationUtil.isValidCNPJ(cnpjValue)) {
            alert('CNPJ inválido');
            return;
        }

        if (!TaxIdValidationUtil.isValidCPF(cpfValue)) {
            alert('CPF inválido');
            return;
        }

        this.state.formatValues.blocked_user_allowed_company_invoices.push({
            cnpj: cnpjValue,
            cpf: cpfValue,
        });

        this.setState({
            blocked_user_allowed_company_invoices: '',
            blocked_user_allowed_company_invoices_cpf: '',
        });
        this.onChange();
    }

    deleteCNPJCPFBlock = (index) => {
        this.state.formatValues.blocked_user_allowed_company_invoices = this.state.formatValues.blocked_user_allowed_company_invoices.filter((_, i) => i !== index,);
        this.setState({});
        this.onChange();
    }

    onChange = () => {
        this.props.onChange(this.state.formatValues);
    }

    showModal = () => {
        this.setState({showModal: !this.state.showModal});
    }

    render() {
        if (!this.context.parent.state.isEditUuid) {
            return <></>;
        }

        return (
            <div>
                <ModalMoreBlockUserComponent showModal={this.state.showModal}
                                             showModalFunc={this.showModal}/>
                <SpacerComponent height={40}/>
                <Box display={'flex'}
                     flexDirection={'row'}
                     alignItems={'center'}>
                    <CheckBoxDefaultComponent onChange={() => {
                        this.state.formatValues.allow_manual_scoring_only = !this.state.formatValues.allow_manual_scoring_only;
                        this.setState({});
                        this.onChange();
                    }}
                                              checked={this.state.formatValues.allow_manual_scoring_only}
                                              label={'Somente Pontuação Manual'}/>
                    <TooltipDefault
                        text={'Ao selecionar esse checkbox, seus clientes poderão ser pontuados somente através da PONTUAÇÃO MANUAL nesse ambiente web. Sendo impedidos de pontuar através de escaneamento de cupons e notas fiscais'}/>
                </Box>
                <SpacerComponent height={20}/>
                <Box display={'flex'}
                     flexDirection={'row'}
                     alignItems={'center'}>
                    <CheckBoxDefaultComponent onChange={() => {
                        this.state.formatValues.block_invoices_no_owner = !this.state.formatValues.block_invoices_no_owner;
                        this.setState({});
                        this.onChange();
                    }}
                                              checked={this.state.formatValues.block_invoices_no_owner}
                                              label={'Notas sem identificação do consumidor não pontuam'}/>
                    <TooltipDefault
                        text={'Ao selecionar esse checkbox, seus clientes não poderão pontuar com notas e cupons fiscais sem identificação de NOME e CPF do cliente'}/>
                </Box>
                <SpacerComponent height={20}/>
                <Box display={'flex'}
                     flexDirection={'row'}
                     alignItems={'center'}>
                    <CheckBoxDefaultComponent onChange={() => {
                        this.state.formatValues.person_invoices_only_owner = !this.state.formatValues.person_invoices_only_owner;
                        this.setState({});
                        this.onChange();
                    }}
                                              checked={this.state.formatValues.person_invoices_only_owner}
                                              label={'Notas com identificação do consumidor (CPF), số podem ser pontuadas pelo proprietário da nota.'}/>
                    <TooltipDefault
                        text={'Ao selecionar esse checkbox, notas identificadas com o NOME e cpf do cliente, só poderão ser pontuadas pelo próprio cliente identificado no documento fiscal.'}/>
                </Box>
                <SpacerComponent height={20}/>
                <Box display={'flex'}
                     flexDirection={'row'}
                     alignItems={'center'}>
                    <CheckBoxDefaultComponent onChange={() => {
                    }}
                                              checked={this.state.formatValues?.blocked_company_invoices?.length > 0}
                                              label={'Nenhuma nota com identificação do consumidor (CNPJ) abaixo, poderá ser pontuada:'}/>
                    <TooltipDefault
                        text={'Marcando esse checkbox e inserindo o número do CNPJ no campo abaixo, nenhuma nota emitida para esse CNPJ poderá ser pontuada por qualquer usuário.'}/>
                </Box>
                <SpacerComponent height={20}/>
                <Typography variant={'subtitle1'}
                            color={'error'}>CNPJ'S BLOQUEADOS PARA
                    ESCANEAMENTO:</Typography>

                <SpacerComponent height={20}/>

                {this.state?.formatValues?.blocked_company_invoices?.map((value, index) => {
                    return <ContentCNPJBlock>
                        <TextFieldDefault
                            name={'blocked_company_invoices_dynamic'}
                            onChange={(event) => this.handleChange(event)}
                            mask={FormMask.cnpj}
                            erros={this.props.erros}
                            disabled={true}
                            value={this.state.formatValues.blocked_company_invoices[index].cnpj}/>
                        <SpacerComponent width={20}/>
                        <DeleteIcon
                            onClick={() => this.deleteCNPJBlock(index)}/>
                    </ContentCNPJBlock>;
                })}

                <ContentCNPJBlock>
                    <TextFieldDefault name={'blocked_company_invoices'}
                                      onChange={(event) => this.handleChange(event)}
                                      mask={FormMask.cnpj}
                                      erros={this.props.erros}
                                      label={'CNPJ'}
                                      value={this.state.blocked_company_invoices}/>
                    <SpacerComponent width={20}/>
                    <AddCircleOutlineIcon onClick={this.addCNPJBlock}/>
                </ContentCNPJBlock>
                <SpacerComponent height={30}/>
                <Typography variant={'subtitle1'}
                            color={'error'}>Notas com identificação do
                    consumidor (CNPJ), só poderão ser pontuadas pelo
                    CPF associado,abaixo:</Typography>
                {this.state?.formatValues?.blocked_user_allowed_company_invoices?.map((value, index) => {
                    return <ContentCNPJBlock>
                        <Typography variant={"body1"}>{index + 1}</Typography>
                        <SpacerComponent width={20}/>
                        <TextFieldDefault
                            name={'blocked_user_allowed_company_invoices_dynamic'}
                            onChange={(event) => this.handleChange(event)}
                            mask={FormMask.cnpj}
                            erros={this.props.erros}
                            disabled={true}
                            value={this.state.formatValues.blocked_user_allowed_company_invoices[index].cnpj}/>
                        <SpacerComponent width={20}/>
                        <TextFieldDefault
                            name={'blocked_user_allowed_company_invoices_dynamic'}
                            onChange={(event) => this.handleChange(event)}
                            mask={FormMask.cpf}
                            erros={this.props.erros}
                            disabled={true}
                            value={this.state.formatValues.blocked_user_allowed_company_invoices[index].cpf}/>
                        {/*<SpacerComponent width={20}/>
                        <DeleteIconStyled onClick={() => this.deleteCNPJCPFBlock(index)}/>*/}
                    </ContentCNPJBlock>;
                })}

                {/*{this.state?.formatValues?.blocked_user_allowed_company_invoices.length <= 24 &&
                    <ContentCNPJBlock>
                        <Typography
                            variant={"body1"}>{this.state?.formatValues?.blocked_user_allowed_company_invoices?.length + 1}</Typography>
                        <SpacerComponent width={20}/>
                        <TextFieldDefault name={'blocked_user_allowed_company_invoices'}
                                          onChange={(event) => this.handleChange(event)}
                                          mask={FormMask.cnpj}
                                          erros={this.props.erros}
                                          label={'CNPJ'}
                                          value={this.state.blocked_user_allowed_company_invoices}/>
                        <SpacerComponent width={20}/>
                        <TextFieldDefault name={'blocked_user_allowed_company_invoices_cpf'}
                                          onChange={(event) => this.handleChange(event)}
                                          mask={FormMask.cpf}
                                          erros={this.props.erros}
                                          label={'CPF'}
                                          value={this.state.blocked_user_allowed_company_invoices_cpf}/>
                        <SpacerComponent width={20}/>
                        <AddCircleOutlineIcon onClick={this.addCNPJCPFBlock}/>
                    </ContentCNPJBlock>
                }*/}

                {this.state?.formatValues?.blocked_user_allowed_company_invoices.length <= 0 &&
                    <ContentCNPJBlock>
                        <SpacerComponent height={50}/>
                        <Button variant="outlined"
                                color="primary"
                                onClick={() => {
                                    this.showModal();
                                }}>
                            CLIQUE AQUI PARA RELACIONAR CPF e CNPJ
                        </Button>
                    </ContentCNPJBlock>
                }

                {this.state?.formatValues?.blocked_user_allowed_company_invoices.length >= 1 &&
                    <ContentCNPJBlock>
                        <SpacerComponent height={50}/>
                        <Button variant="outlined"
                                color="primary"
                                onClick={() => {
                                    this.showModal();
                                }}>
                            CLIQUE AQUI PARA ALTERAR CPF e CNPJ
                        </Button>
                    </ContentCNPJBlock>
                }

                <SpacerComponent height={40}/>
            </div>
        );
    }
}

BlockUserComponent.propTypes = {};

export default BlockUserComponent;
